const modalInitialState = {
    modal: {
        show: false,
        data: {
            template: null,
            params: null,
            listBotones: null,
            posicion: null,
            bloquearDissmiss: null
        }
    },
};

export default modalInitialState;